import {
    UsergroupAddOutlined,
    HeatMapOutlined,
  } from '@ant-design/icons';
  import { APP_PREFIX_PATH } from 'configs/AppConfig'
  import timeArena from '../../menus/icons/timeArena.js'
  import pizarron from '../../menus/icons/pizarron'
  import graduacionCap from '../../menus/icons/graduacionCap.js'
  import checkIcono from '../../menus/icons/check.js'
  import reloadIcono from '../../menus/icons/reloadIcono.js'
  import checkUser from '../../menus/icons/checkUser.js'
  import game from '../../menus/icons/game.js'

let AdminModuloAcademica = [
  {
    key: "Academica",
    path: `${APP_PREFIX_PATH}/admin/academica`,
    title: "sidenav.admin.condiguracionAcademica.condiguracionAcademica",
    icon: graduacionCap,
    breadcrumb: true,
    permission:['Read:gruposClase'],
    submenu: [
      {
        key: "Grupos",
        path: `${APP_PREFIX_PATH}/admin/grupos`,
        title: "sidenav.admin.condiguracionAcademica.grupos",
        icon: pizarron,
        breadcrumb: true,
        permission:['Read:gruposClase'],
      },
      {
        key: "Evaluaciones",
        path: `${APP_PREFIX_PATH}/admin/evaluaciones`,
        title: "sidenav.admin.condiguracionAcademica.evaluacion.evaluacion",
        icon: checkIcono,
        breadcrumb: true,
        permission:['Read:periodoA'],
        submenu: [
          {
            key: "Periodos",
            path: `${APP_PREFIX_PATH}/admin/evaluaciones/periodos`,
            title: "sidenav.admin.condiguracionAcademica.evaluacion.periodos",
            icon: timeArena,
            breadcrumb: true,
            permission:['Read:periodoA'],
            submenu: [],
            
          },
          {
            key: "Incidencias",
            path: `${APP_PREFIX_PATH}/admin/evaluaciones/incidencias`,
            title:
              "sidenav.admin.condiguracionAcademica.evaluacion.incidencias",
            icon: HeatMapOutlined,
            breadcrumb: true,
            permission:['Read:incidencias'],
            submenu: [],
          },
          {
            key: "Gamificación",
            path: `${APP_PREFIX_PATH}/admin/evaluaciones/gamificacion`,
            title:
              "sidenav.admin.condiguracionAcademica.evaluacion.gamificacion",
            icon: game,
            breadcrumb: true,
            permission:['Read:gamificacion'],
            submenu: [],
          },
        ],
      },
      {
        key: "Admisiones",
        path: `${APP_PREFIX_PATH}/admin/admision`,
        title: "sidenav.admin.condiguracionAcademica.inscripciones.admision",
        icon: checkUser,
        breadcrumb: true,
        permission:['Read:procesoAdmision'],
        submenu: [
          {
            key: "Procesos de admisión",
            path: `${APP_PREFIX_PATH}/admin/inscripciones/admision`,
            title:
              "sidenav.admin.condiguracionAcademica.inscripciones.procesos_admision",
            icon: checkUser,
            breadcrumb: true,
            permission:['Read:procesoAdmision'],
            submenu: [],
          },
          {
            key: "Solicitantes",
            path: `${APP_PREFIX_PATH}/admin/usuarios/list/8`,
            title:
              "sidenav.admin.condiguracionAcademica.inscripciones.solicitantes",
            icon: UsergroupAddOutlined,
            breadcrumb: true,
            permission:['Read:procesoAdmisionSolicitantes'],
            submenu: [],
          },
        ],
      },
      {
        key: "Inscripciones",
        path: `${APP_PREFIX_PATH}/admin/inscripciones`,
        title:
          "sidenav.admin.condiguracionAcademica.inscripciones.inscripciones",
        icon: reloadIcono,
        breadcrumb: true,
        permission:['Read:periodoA'],
        submenu: [
          {
            key: "Inscripciones Masiva",
            path: `${APP_PREFIX_PATH}/admin/inscripciones/masiva`,
            title: "sidenav.admin.condiguracionAcademica.inscripciones.masiva",
            icon: UsergroupAddOutlined,
            permission:['Read:periodoA'],
            breadcrumb: true,
            submenu: [],
          },
        ],
      },
    ],
  },
];

export default AdminModuloAcademica;
